import { render, staticRenderFns } from "./LivestockList.vue?vue&type=template&id=f48937fe&"
import script from "./LivestockList.vue?vue&type=script&lang=js&"
export * from "./LivestockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports